"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hemi = void 0;
exports.hemi = {
    "addresses": {
        "ProxyAdmin": "0xd6062F989BCf5DD6871A83671C4aABD05e25BA1b",
        "Multicall2": "0xcA11bde05977b3631167028862bE2a173976CA11",
        "Sumer": "0x553d713e0fB958932b6C40ABAf0b5A1fFae73Da2",
        "CompoundLens": "0x607728B392D4d18e7fe072f0F8D4EFd5c8D0F5A4",
        "FeedPriceOracle": "0x10A2e256Bed7b3c49C151Ad1Bad01F4936FC9276",
        "CompLogic": "0x16C7d1F9EA48F7DE5E8bc3165A04E8340Da574fA",
        "RedemptionManager": "0x6116438fD4abDd902dcA8e0335144F700B1a5147",
        "Timelock": "0xe19FD48C972E2dB074C4B0B29Ff2f0d3E1aefe52",
        "Comptroller": "0xB2fF02eEF85DC4eaE95Ab32AA887E0cC69DF8d8E",
        "sdrETH": "0x8c1ad24cA39FE45E97CD9862364128406E3B03F3",
        "ETH": "0x0000000000000000000000000000000000000000",
        "CErc20": "0x163cEbBD83A4e2821fF06C9b0707A8A64FEc0AbC",
        "suErc20": "0x9aa55bCf3E41D0d98FCe816C4eC6E791B0f6d154",
        "JumpRate#StableBC": "0x0f0af0e3dEb8A884fCB54907BA571c84C2EB3042",
        "JumpRate#ETH": "0x621492F55F6b7A29FDaC0844B1A6C849985A4b82",
        "JumpRate#Others": "0x2d9b96648C784906253c7FA94817437EF59Cf226",
        "JumpRate#BTCBC_AltStables": "0x7032b30FEF73af49e314e5A09B449046ef046309",
        "ZeroRate": "0x3EC1D6e0B44c8a2a8855aEb71f35355459478482",
        "sdrUSDC": "0xA6ae238D9CaF65DFA67670FDE3156EFeE9334488",
        "USDC": "0xad11a8BEb98bbf61dbb1aa0F6d6F2ECD87b35afA",
        "sdrUSDT": "0x7f5a7aE2688A7ba6a9B36141335044c058a08b3E",
        "USDT": "0xbB0D083fb1be0A9f6157ec484b6C79E0A4e31C2e",
        "sdrrsETH": "0x7465fedB29023d11effe8C74E82A7ecEBf15E947",
        "rsETH": "0xc3eACf0612346366Db554C991D7858716db09f58",
        "sdrhemiBTC": "0xdb4d020A58e0A1A67823d75437A61044dC02AE4C",
        "hemiBTC": "0xAA40c0c7644e0b2B224509571e10ad20d9C4ef28",
        "sdrWBTC": "0x58235d9C8c9f136c0A4e9761186dB0329243bbB8",
        "WBTC": "0x03C7054BCB39f7b2e5B2c7AcB37583e32D70Cfa3",
        "sdrsuUSD": "0x8C38b023Afe895296e2598AE111752223185b35c",
        "suUSD": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
        "sdrsuETH": "0xb1FdC3f660b0953253141B2509c43014d5d3d733",
        "suETH": "0x1c22531AA9747d76fFF8F0A43b37954ca67d28e0",
        "sdrsuBTC": "0xc7fFEAa5949d50A408bD92DdB0D1EAcef3F8a3Bc",
        "suBTC": "0xe85411C030fB32A9D8b14Bbbc6CB19417391F711"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC",
            "ctokenAddr": "0xA6ae238D9CaF65DFA67670FDE3156EFeE9334488",
            "underlySym": "USDC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xad11a8BEb98bbf61dbb1aa0F6d6F2ECD87b35afA",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDT",
            "ctokenAddr": "0x7f5a7aE2688A7ba6a9B36141335044c058a08b3E",
            "underlySym": "USDT",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xbB0D083fb1be0A9f6157ec484b6C79E0A4e31C2e",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrrsETH",
            "ctokenAddr": "0x7465fedB29023d11effe8C74E82A7ecEBf15E947",
            "underlySym": "rsETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xc3eACf0612346366Db554C991D7858716db09f58",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrhemiBTC",
            "ctokenAddr": "0xdb4d020A58e0A1A67823d75437A61044dC02AE4C",
            "underlySym": "hemiBTC",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xAA40c0c7644e0b2B224509571e10ad20d9C4ef28",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrWBTC",
            "ctokenAddr": "0x58235d9C8c9f136c0A4e9761186dB0329243bbB8",
            "underlySym": "WBTC",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x03C7054BCB39f7b2e5B2c7AcB37583e32D70Cfa3",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrsuUSD",
            "ctokenAddr": "0x8C38b023Afe895296e2598AE111752223185b35c",
            "underlySym": "suUSD",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsuETH",
            "ctokenAddr": "0xb1FdC3f660b0953253141B2509c43014d5d3d733",
            "underlySym": "suETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x1c22531AA9747d76fFF8F0A43b37954ca67d28e0",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrsuBTC",
            "ctokenAddr": "0xc7fFEAa5949d50A408bD92DdB0D1EAcef3F8a3Bc",
            "underlySym": "suBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xe85411C030fB32A9D8b14Bbbc6CB19417391F711",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrETH",
            "ctokenAddr": "0x8c1ad24cA39FE45E97CD9862364128406E3B03F3",
            "underlySym": "ETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": true,
            "permitEnabled": false,
            "underlyAddr": "0x0000000000000000000000000000000000000000"
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#ETH",
            "contract": "JumpRateModelV2",
            "address": "0x621492F55F6b7A29FDaC0844B1A6C849985A4b82",
            "tokens": [
                "ETH",
                "ETH"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.036",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.75"
        },
        {
            "name": "JumpRate#StableBC",
            "contract": "JumpRateModelV2",
            "address": "0x0f0af0e3dEb8A884fCB54907BA571c84C2EB3042",
            "tokens": [
                "USDC",
                "USDT",
                "WBTC"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.09333",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.75"
        },
        {
            "name": "JumpRate#Others",
            "contract": "JumpRateModelV2",
            "address": "0x2d9b96648C784906253c7FA94817437EF59Cf226",
            "tokens": [
                "rsETH",
                "hemiBTC"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.15555",
            "jumpMultiplierPerYear": "5.582",
            "kink": "0.45"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0x3EC1D6e0B44c8a2a8855aEb71f35355459478482",
            "tokens": [
                "suUSD",
                "suETH",
                "suBTC"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=hemi.js.map